import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation  } from 'react-router-dom';
import { useGetChapterNumbers, useGetCompanies } from '../../../../api/masters/masters';
import { ErrorInfo } from '../../../../api/model';
import { useGetOrganizationsTeams } from '../../../../api/origanization/origanization';
import { useGetPrivileges } from '../../../../api/privilege/privilege';
import { usePostUsersDetail } from '../../../../api/users/users';
import { useDefaultOptions } from '../../../../hooks/api';
import { UserForm } from './UserForm';

interface State {
  transitionSource: string;
}
function UserFormPage() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { userId } = useParams();
  const options = useDefaultOptions(language);

  const companies = useGetCompanies(options);

  const location = useLocation();
  const { transitionSource } = location.state as State;

  // グループ・チーム
  const teams = useGetOrganizationsTeams({}, options);

  // 権限リスト
  const priviledges = useGetPrivileges(options);

  // 原稿編集
  const chapterNumbers = useGetChapterNumbers(options);

  const { data, mutateAsync } = usePostUsersDetail<AxiosError<ErrorInfo>, unknown>(options);

  useEffect(() => {
    const postUserDetail = async () => {
      await mutateAsync({ data: { user_id: Number(userId) } });
    };
    void postUserDetail();
  }, [userId, mutateAsync]);

  if (userId == null) {
    return <div id="main">{t('この URL は存在しません。')}</div>;
  }

  const user = data?.data;
  if (!user) {
    return <div id="main">{t('お待ちください。')}</div>;
  }

  return (
    <UserForm
      user={user}
      companies={companies.data?.data.companies || []}
      priviledges={priviledges.data?.data.privileges_list_items || []}
      chapterNumbers={chapterNumbers.data?.data.chapter_numbers || []}
      teamCompanies={teams.data?.data.companies || []}
      transitionSource={transitionSource}
    />
  );
}

export default UserFormPage;
